import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { profile } from "../../data/mock";
import { trackCoachingCta } from "../../lib/analytics";

const CoachingNav = ({ t }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    [t.ui.navPaths, "#paths"],
    [t.ui.navProcess, "#process"],
    [t.ui.navTrust, "#trust"],
  ];

  return (
    <header
      data-testid="coaching-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#05070B]/90 backdrop-blur-md border-b border-[#1E90FF]/15" : "bg-transparent"
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-10 h-16 md:h-20 flex items-center justify-between gap-3">
        <Link to="/" data-testid="coaching-nav-home-link" className="flex items-center gap-2.5 min-w-0">
          <img src={profile.logo} alt="Bluebloodfr logo" width="32" height="32" className="w-8 h-8 object-contain shrink-0" />
          <span className="hidden sm:flex items-center gap-1.5 text-[#A1A7B3] hover:text-[#1E90FF] text-xs tracking-wider transition-colors">
            <ArrowLeft size={13} /> {t.backToPortfolio}
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-7">
          {links.map(([label, href]) => (
            <a key={href} href={href} data-testid={`coaching-nav-${href.slice(1)}`}
              className="text-[#C8CED8] hover:text-[#1E90FF] text-sm font-medium transition-colors">
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to={t.altPath}
            hrefLang={t.locale === "fr" ? "en" : "fr"}
            aria-label={t.ui.langSwitchAria}
            data-testid="coaching-lang-switch"
            className="h-9 px-3 inline-flex items-center rounded-full border border-[#1E90FF]/30 text-[#C8CED8] hover:text-[#F3F6FA] hover:border-[#1E90FF] font-mono text-xs transition-colors"
          >
            <span className={t.locale === "fr" ? "text-[#1E90FF]" : ""}>FR</span>
            <span className="mx-1.5 text-[#A1A7B3]/50">/</span>
            <span className={t.locale === "en" ? "text-[#1E90FF]" : ""}>EN</span>
          </Link>
          <a
            href="#request"
            onClick={() => trackCoachingCta("navigation")}
            data-testid="coaching-nav-cta"
            className="h-9 px-4 inline-flex items-center rounded-full bg-[#1E90FF] hover:bg-[#0066CC] text-white text-xs sm:text-sm font-semibold transition-colors"
          >
            {t.ui.navContact}
          </a>
        </div>
      </div>
    </header>
  );
};

export default CoachingNav;
